import json from './sprite.js';

export default {
    handle: 'ENG_SPS10-Recess',
    label: 'en_SPS10-Recess_225002480',
    json,
};
